<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'serviceData.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="sd-details-close-icon"
      (click)="dialogRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (extendedServiceData$ | async; as serviceData) {
      @if (sharedServiceData$ | async; as sharedServiceData) {
        <!--      Personal information-->
        <div class="d-flex justify-content-between align-items-end mb-1">
          <p class="caption mb-1">
            {{ 'common.titleBaseInformation' | translate }}
          </p>
          <div class="text-end col-3">
            <button
              class="icon-btn mb-1 me-1"
              ngbTooltip="Follow ups"
              triggers="hover"
              placement="left"
              *appRequirePermission="'followUps'"
              status="primary"
              size="small"
              type="submit"
              [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
              [class.icon-btn-lg]="coreUtilsService.tabletMode()"
              (click)="
                followUpsUtils.openFollowUpsListDialog(serviceData.followUpIds)
              "
            >
              <i class="fa-light fa-square-exclamation fa-fw"></i>
            </button>
            <button
              class="icon-btn mb-1 me-1"
              ngbTooltip="Add follow up"
              triggers="hover"
              placement="left"
              *appRequirePermission="'followUps'"
              status="primary"
              size="small"
              [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
              [class.icon-btn-lg]="coreUtilsService.tabletMode()"
              (click)="addFollowUp(serviceData)"
            >
              <i
                class="fa-kit fa-light-square-exclamation-circle-plus fa-fw"
              ></i>
            </button>
            <ng-container
              *appRequirePermission="'serviceData.buttons.paymentDetails'"
            >
              <button
                class="icon-btn"
                ngbTooltip="{{
                  'serviceData.list.buttons.paymentDetails' | translate
                }}"
                triggers="hover"
                placement="left"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="openPaymentDetails(serviceData.id)"
              >
                <i class="fa-light fa-credit-card"></i>
              </button>
            </ng-container>
            <ng-container *appRequirePermission="'serviceData.buttons.edit'">
              <button
                class="icon-btn mb-1 ms-1"
                ngbTooltip="{{ 'serviceData.list.buttons.edit' | translate }}"
                triggers="hover"
                placement="left"
                status="primary"
                size="small"
                type="submit"
                data-cy="edit-sd-btn"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="editServiceData(serviceData.id)"
              >
                <i class="fa-light fa-pen fa-fw"></i>
              </button>
            </ng-container>
          </div>
        </div>
        <hr class="mt-0" />
        <div class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="reference-key-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.referenceKey' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.referenceKey }}
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="partner-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.partner' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.partner?.name }}
            </div>
          </div>
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="country-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.country' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.partner?.address.country }}
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="generated-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.generated' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.generated | date }}
            </div>
          </div>
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="bundles-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.bundles' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              @for (bundle of serviceData.bundles; track bundle.id) {
                <div>{{ bundle.internalName }}</div>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="last-status-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.lastStatus' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.status }}
            </div>
          </div>
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="last-status-change-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.lastStatusChanged' | translate
            }}</label>

            <div class="col-12 col-sm-8">
              {{ serviceData.statusChanged | date }}
            </div>
          </div>
        </div>
        <div class="row">
          <div
            *appRequirePermission="'patientInformation'"
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="name-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.name' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.patientInformation.firstName }}
              {{ serviceData.patientInformation.lastName }}
            </div>
          </div>
          <div
            *appRequirePermission="'medicalInformation'"
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="date-of-birth-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.dateOfBirth' | translate
            }}</label>

            <div class="col-12 col-sm-8">
              {{
                getDateOnly(serviceData.patientInformation.dateOfBirth) | date
              }}
            </div>
          </div>
        </div>
        @if (
          fieldSet.includes(ServiceDataFields.Height) &&
          fieldSet.includes(ServiceDataFields.Weight)
        ) {
          <div *appRequirePermission="'medicalInformation'" class="row">
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="height-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.height' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ serviceData.patientInformation.height }} cm
              </div>
            </div>
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="weight-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.weight' | translate
              }}</label>

              <div class="col-12 col-sm-8">
                {{ serviceData.patientInformation.weight }} kg
              </div>
            </div>
          </div>
        }
        <div *appRequirePermission="'patientInformation'" class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="phone-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.phone' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.patientInformation.phoneNumber }}
            </div>
          </div>
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="email-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.email' | translate
            }}</label>

            <div class="col-12 col-sm-8">
              {{ serviceData.patientInformation.email }}
            </div>
          </div>
        </div>
        <div class="row">
          @if (serviceData.patientInformation.documentNumber) {
            <div
              *appRequirePermission="'serviceData.documentNumber'"
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="document-number-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.documentNumber' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ serviceData.patientInformation.documentNumber }}
              </div>
            </div>
          }
        </div>
        <!--      End Personal information-->
        <!--      Service information-->
        <div class="d-flex justify-content-between align-items-end">
          <p class="caption mb-1">
            {{ 'serviceData.details.serviceInformation' | translate }}
          </p>
        </div>
        <hr class="mt-0" />
        @if (serviceData.dateOfService) {
          <div class="row">
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="doctor-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.dateOfService' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ serviceData.dateOfService | date }}
              </div>
            </div>
          </div>
        }

        <div class="row">
          <div
            class="col-12 col-md-6 row align-items-center mb-2"
            data-cy="doctor-row"
          >
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.nipt.doctor' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{ serviceData.doctor?.name }}
            </div>
          </div>
          @if (fieldSet.includes(ServiceDataFields.GenderInformation)) {
            <div
              *appRequirePermission="'medicalInformation'"
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="gender-info-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.genderInformation' | translate
              }}</label>

              <div class="col-12 col-sm-8">
                {{
                  serviceData.serviceInformation.nipt.provideGenderInformation
                    ? 'YES'
                    : 'NO'
                }}
              </div>
            </div>
          }
        </div>
        <div *appRequirePermission="'medicalInformation'" class="row mb-2">
          @if (fieldSet.includes(ServiceDataFields.PregnancyType)) {
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="pregnancy-type-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.pregnancyType' | translate
              }}</label>

              <div class="col-12 col-sm-8">
                {{
                  sharedServiceData.serviceInformation.shared
                    .currentPregnancyInformation.pregnancyType
                }}
              </div>
            </div>
          }
          @if (fieldSet.includes(ServiceDataFields.IncidentalFindings)) {
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="incidental-findings-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.incidentalFindings' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{
                  serviceData.serviceInformation.nipt.incidentalFindings
                    ? 'YES'
                    : 'NO'
                }}
              </div>
            </div>
          }
        </div>
        @if (fieldSet.includes(ServiceDataFields.DueDate)) {
          <div *appRequirePermission="'medicalInformation'" class="row">
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="due-date-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.estimatedDueDate' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{
                  sharedServiceData.serviceInformation.shared
                    .currentPregnancyInformation.expectedConfinementDate | date
                }}
              </div>
            </div>
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="gestation-age-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.nipt.gestationAge' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{
                  sharedServiceData.serviceInformation.shared
                    .currentPregnancyInformation.gestationAge.week
                }}W
                {{
                  sharedServiceData.serviceInformation.shared
                    .currentPregnancyInformation.gestationAge.day
                }}D
              </div>
            </div>
          </div>
        }
        @if (canViewCommentsAndNotes()) {
          <div class="d-flex justify-content-between align-items-end">
            <p class="caption mb-1">
              {{ 'serviceData.details.commentsAndNotes' | translate }}
            </p>
          </div>
          <hr class="mt-0" />
          <div class="row mb-2">
            <div
              *appRequirePermission="'serviceData.details.patientState'"
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="patient-state-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.patientState' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{
                  sharedServiceData.serviceInformation.shared.comments || '—'
                }}
              </div>
            </div>
            <div
              *appRequirePermission="'serviceData.details.notes'"
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="notes-row"
            >
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.notes' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ serviceData.notes || '—' }}
              </div>
            </div>
          </div>
        }
        <div class="d-flex justify-content-between align-items-end">
          <p class="caption mb-1">
            {{ 'serviceData.details.otherInformation' | translate }}
          </p>
        </div>
        <hr class="mt-0" />
        <div class="row mb-2">
          <div class="col-12 col-md-6 row align-items-center mb-2">
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.reportLanguage' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              {{
                (sharedServiceData.reportLanguageId
                  | displayName: languages()) || '—'
              }}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-end mb-1">
          <p class="caption mb-1">
            {{ 'serviceData.details.samples' | translate }}
          </p>
          <div class="text-end col-3">
            <button
              class="icon-btn"
              ngbTooltip="{{ 'serviceData.details.manageSamples' | translate }}"
              triggers="hover"
              placement="left"
              type="submit"
              [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
              [class.icon-btn-lg]="coreUtilsService.tabletMode()"
              (click)="manageSamples(serviceData.id, serviceData.sampleIds)"
            >
              <i class="fa-light fa-droplet"></i>
            </button>
          </div>
        </div>
        <hr class="mt-0" />
        <app-samples-list
          [serviceDataId]="serviceData.id"
          [readonly]="true"
        ></app-samples-list>

        <!--      End Nipt service information-->
      } @else {
        <div class="py-4 loading"></div>
      }
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dialogRef.close()"
      data-cy="sd-details-close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
